(function () {
  'use strict';
  var toastEl, toastTimer;

  function toast(html) {
    toastEl = toastEl || document.getElementById('toast');
    if (!toastEl) return;
    toastEl.innerHTML = html;
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4000);
  }

  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t;
    return d.innerHTML;
  }

  function refreshCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }

  // Add to cart without leaving the page. Falls back to a normal form submit on errors.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'ADDING...'; }
    var url = (window.zeel && window.zeel.cartAddUrl ? window.zeel.cartAddUrl : '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
        return refreshCount().then(function () {
          toast('Added to cart. <a href="' + ((window.zeel && window.zeel.cartUrl) || '/cart') + '">View cart</a>');
        });
      })
      .catch(function (err) { toast(esc(err.message)); })
      .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  });

  // Auto-apply filters and sorting.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el.form && (el.form.id === 'filters' || el.form.id === 'filters-sort')) {
      el.form.submit();
    }
  });
})();

(function () {
  'use strict';
  // Slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('.slide'));
    var dots = [].slice.call(root.querySelectorAll('[data-dot]'));
    var i = 0, timer = null;
    var auto = root.getAttribute('data-autoplay') === 'true';
    var iv = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!auto || reduce || slides.length < 2) return;
      timer = setInterval(function () { show(i + 1); }, iv);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-prev],[data-next],[data-dot]');
      if (!b) return;
      if (b.hasAttribute('data-prev')) show(i - 1);
      else if (b.hasAttribute('data-next')) show(i + 1);
      else show(dots.indexOf(b));
      start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (!t) return;
      var n = parseInt(t.getAttribute('data-thumb'), 10);
      slides.forEach(function (s, k) { s.hidden = k !== n; });
      thumbs.forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
    });
  });
})();

(function () {
  'use strict';
  // ---- Join Our Circle ----
  var c = document.querySelector('[data-circle]');
  if (c) {
    var pill = c.querySelector('[data-circle-pill]');
    var modal = c.querySelector('[data-circle-modal]');
    var back = c.querySelector('[data-circle-backdrop]');
    var key = 'zeelCircleHidden';
    try { if (sessionStorage.getItem(key)) pill.hidden = true; } catch (e) {}
    function openM() { modal.hidden = false; back.hidden = false; pill.hidden = true; var f = modal.querySelector('input:not([type=hidden])'); if (f) f.focus(); }
    function closeM() { modal.hidden = true; back.hidden = true; pill.hidden = false; }
    c.addEventListener('click', function (e) {
      if (e.target.closest('[data-circle-open]')) openM();
      else if (e.target.closest('[data-circle-close]') || e.target === back) closeM();
      else if (e.target.closest('[data-circle-dismiss]')) { pill.hidden = true; try { sessionStorage.setItem(key, '1'); } catch (er) {} }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeM(); });
    if (c.querySelector('[data-circle-posted]')) { pill.hidden = false; openM(); }
  }

  // ---- Chat assistant (keyword based, uses your store's products) ----
  var root = document.querySelector('[data-chat]');
  if (!root) return;
  var data = {};
  try { data = JSON.parse(document.getElementById('chat-data').textContent); } catch (e) { data = { products: [] }; }
  var panel = root.querySelector('.chat-panel'), log = root.querySelector('[data-chat-log]');
  var form = root.querySelector('[data-chat-form]'), input = form.querySelector('input'), chips = root.querySelector('[data-chat-chips]');
  var fab = root.querySelector('.chat-fab'), started = false;
  var products = data.products || [];

  var topics = [
    { words: ['skin', 'hair', 'glow', 'radiance', 'glutathione', 'biotin', 'beauty', 'tvacha', 'baal'], key: 'radiance' },
    { words: ['collagen', 'ageing', 'aging', 'wrinkle', 'elasticity', 'firmness'], key: 'ageing' },
    { words: ['hydrate', 'hydration', 'electrolyte', 'dehydrat', 'thirst', 'workout', 'paani'], key: 'hydrate' },
    { words: ['sleep', 'dreams', 'relax', 'stress', 'insomnia', 'neend', 'bedtime'], key: 'dreams' },
    { words: ['gut', 'belly', 'bloat', 'digest', 'probiotic', 'prebiotic', 'pet', 'acidity'], key: 'belly' },
    { words: ['protein', 'crisps', 'snack', 'crunch', 'namkeen', 'chips'], key: 'crisps' }
  ];
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function add(who, html) {
    var m = document.createElement('div'); m.className = 'msg ' + who; m.innerHTML = html;
    log.appendChild(m); log.scrollTop = log.scrollHeight;
  }
  function findProducts(q) {
    var out = [];
    topics.forEach(function (t) {
      if (t.words.some(function (w) { return q.indexOf(w) > -1; })) {
        products.forEach(function (p) {
          var hay = (p.title + ' ' + p.url).toLowerCase();
          if (hay.indexOf(t.key) > -1 && out.indexOf(p) < 0) out.push(p);
        });
      }
    });
    products.forEach(function (p) {
      var name = p.title.toLowerCase().replace('zeel', '').trim();
      if (name && q.indexOf(name.split(' ').slice(0, 2).join(' ')) > -1 && out.indexOf(p) < 0) out.push(p);
    });
    if (/non[\s-]?veg|marine|fish/.test(q)) out = out.filter(function (p) { return p.tags.indexOf('Non-Veg') > -1; }).concat(out.length ? [] : products.filter(function (p) { return p.tags.indexOf('Non-Veg') > -1; }));
    else if (/\bveg\b|vegetarian|shakahari/.test(q)) out = out.length ? out.filter(function (p) { return p.tags.indexOf('Non-Veg') < 0; }) : products.filter(function (p) { return p.tags.indexOf('Veg') > -1; });
    return out.slice(0, 3);
  }
  function card(p) {
    return '<a class="pcard" href="' + esc(p.url) + '"><strong>' + esc(p.title) + '</strong><br>' + esc(p.price) + (p.available ? '' : ' (sold out)') + '</a>';
  }
  function sentences(p, q) {
    var words = q.split(/[^a-z0-9]+/).filter(function (w) { return w.length > 3 && !/what|which|that|this|have|does|with|your|about|tell|kitna|kaise/.test(w); });
    var parts = (p.desc || '').match(/[^.!?]+[.!?]*/g) || [];
    var hit = parts.filter(function (s) { return words.some(function (w) { return s.toLowerCase().indexOf(w) > -1; }); });
    return (hit.length ? hit : parts).slice(0, 2).join(' ');
  }
  function answer(raw) {
    var q = raw.toLowerCase().trim();
    if (!q) return;
    if (/^(hi|hello|hey|namaste|hii+)\b/.test(q)) return 'Hello! Ask me about any Zeel product, price, ingredients, shipping or returns.';
    if (/ship|deliver|dispatch|courier|kab tak|tracking/.test(q)) return 'Orders usually ship in 1 to 3 business days and arrive in about 3 to 7 business days. Details: <a href="/pages/shipping-delivery">Shipping &amp; Delivery</a>.';
    if (/return|refund|cancel|exchange|damag|wapas/.test(q)) return 'Please see our <a href="/pages/refund-policy">Refund Policy</a>. For damaged or wrong items, contact us within 48 hours of delivery.';
    if (/contact|call|phone|email|mail|whatsapp|human|support|number|address/.test(q)) return 'You can reach us at <a href="tel:' + esc((data.phone || '').replace(/\s/g, '')) + '">' + esc(data.phone || '') + '</a> or <a href="mailto:' + esc(data.email || '') + '">' + esc(data.email || '') + '</a>, or use the <a href="/pages/contact">Contact page</a>.';
    if (/order status|my order|where is my order/.test(q)) return 'For order help, please share your order number through our <a href="/pages/contact">Contact page</a> and we will check for you.';
    var found = findProducts(q);
    if (/price|cost|kitna|kitne|daam|rate|rs\b|₹|cheap|offer|discount/.test(q)) {
      var list = found.length ? found : products;
      if (!list.length) return 'I could not find product prices right now. Please check the shop page.';
      return 'Here are the prices:' + list.slice(0, 7).map(card).join('');
    }
    if (found.length) {
      var p = found[0];
      var info = sentences(p, q);
      return (info ? esc(info) + '<br>' : '') + found.map(card).join('') + '<br><small>This is general product information, not medical advice.</small>';
    }
    if (/product|range|collection|what do you|sell|sab kuch|list|show/.test(q) && products.length) {
      return 'Our products:' + products.slice(0, 7).map(card).join('');
    }
    return 'I am not sure about that. Try asking about a product (for example sleep, gut, collagen, protein, hydration), prices, shipping or returns. You can also call <a href="tel:' + esc((data.phone || '').replace(/\s/g, '')) + '">' + esc(data.phone || '') + '</a>.';
  }
  function send(text) {
    if (!text.trim()) return;
    add('me', esc(text));
    setTimeout(function () { add('bot', answer(text)); }, 250);
  }
  function setOpen(open) {
    panel.hidden = !open; fab.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && !started) {
      started = true;
      add('bot', esc(data.greeting || 'Hi! How can I help?'));
      ['Show products', 'Prices', 'Help me sleep', 'Gut health', 'Shipping', 'Contact'].forEach(function (t) {
        var b = document.createElement('button'); b.type = 'button'; b.textContent = t; chips.appendChild(b);
      });
    }
    if (open) input.focus();
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-chat-toggle]')) setOpen(panel.hidden);
    var b = e.target.closest('[data-chat-chips] button');
    if (b) send(b.textContent);
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); var v = input.value; input.value = ''; send(v); });
})();
